export default "__VITE_ASSET__WCzKJVvp__"